import {Link} from 'react-router-dom';

const ReturnHomeButton = () => {
	return (
		<div className='mb-0'>
			<Link to='/dashboard' className='btn btn-sm btn-primary'>
				Return Home
			</Link>
		</div>
	);
};

export default ReturnHomeButton;
